import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { AuthProvider } from '@/context/AuthContext';
import ProtectedRoute from '@/components/ProtectedRoute';
import Landing from '@/pages/Landing';
import Dashboard from '@/pages/Dashboard';
import PaymentSuccess from '@/pages/PaymentSuccess';
import AdminPanel from '@/pages/AdminPanel';
import EmbedApp from '@/pages/EmbedApp';
import ResetPassword from '@/pages/ResetPassword';
import appConfig from '@/config/appConfig';
import '@/App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App grain-texture">
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
            <Route path="/admin" element={
              <ProtectedRoute>
                <AdminPanel />
              </ProtectedRoute>
            } />
            <Route path="/payment-success" element={
              <ProtectedRoute>
                <PaymentSuccess />
              </ProtectedRoute>
            } />
            
            {/* Embed routes (no auth required) */}
            <Route path="/embed/:appId" element={<EmbedApp />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            
            {appConfig.map(app => (
              <Route 
                key={app.id} 
                path={app.path} 
                element={
                  <ProtectedRoute>
                    <app.component />
                  </ProtectedRoute>
                }
              />
            ))}
            
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-center" richColors />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;